import { FC } from 'react';
import { ProgressSpinner } from 'primereact/progressspinner';
import classes from './Spinner.module.css';

interface Props {
  secondary?: boolean;
  height?: string;
  width?: string;
  centerHeight?: string;
  centerWidth?: string;
  dataTestId?: string;
}

const Spinner: FC<Props> = ({
  secondary,
  height,
  width,
  centerHeight,
  centerWidth,
  dataTestId,
}) => {
  const fill = secondary ? '#079e88' : '#0051FF';
  return (
    <div
      className={classes.Container}
      style={{
        height,
        width,
      }}
      data-testid={dataTestId}
    >
      <ProgressSpinner
        style={{ width: centerWidth, height: centerHeight }}
        strokeWidth="6"
        animationDuration="1s"
        pt={{ circle: { stroke: fill } }}
      />
    </div>
  );
};

Spinner.defaultProps = {
  secondary: false,
  height: '100vh',
  width: '100vw',
  centerHeight: '120px',
  centerWidth: '120px',
  dataTestId: 'spinner',
};

export default Spinner;
